import { render, staticRenderFns } from "./OrderDocumentListPublic.vue?vue&type=template&id=9ef5c2f6"
import script from "./OrderDocumentListPublic.vue?vue&type=script&lang=js"
export * from "./OrderDocumentListPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports